import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { translate } from '../../../../../utils/util';
import HomeDefault from '../../../../../components/HomeDefaultComponent';

const Vehicle = () => {
    const menu = () => {
        let menuItems = [];
        menuItems = [...menuItems, { route: 'vehicle/insert', icon: 'mdi mdi-plus-box-outline', text: translate('new-vehicle', 'stock') }];
        menuItems = [...menuItems, { route: 'vehicle/list', icon: 'mdi mdi-clipboard-list-outline', text: translate('list-vehicle', 'stock') }];
        return menuItems;
    };

    const title = { icon: "mdi mdi-clipboard-check-outline", label: translate('form-deem-sqp', 'deemsqp') };

    const subtitles = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-domain", label: translate('vehicle', 'stock') }];
        return subtitlesItems;
    }

    return (
        <HomeDefault menu={menu()} title={title} subtitles={subtitles()} />
    );
};

export default withRouter(withTranslation()(Vehicle));
